import { render, staticRenderFns } from "./MhDelegateLinks.vue?vue&type=template&id=2d9f8d86&"
import script from "./MhDelegateLinks.vue?vue&type=script&lang=js&"
export * from "./MhDelegateLinks.vue?vue&type=script&lang=js&"
import style0 from "./MhDelegateLinks.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports